var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-attach"},[(_vm.canUpload && _vm.hasUpFilePower)?_c('upload-attach',{staticClass:"upload-btn",on:{"uploaded":_vm.uploadedFile}}):_vm._e(),_c('new-table',{ref:"attchTableRef",attrs:{"data":_vm.attachList,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }